var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3536 8.64645C9.15834 8.45118 8.84176 8.45118 8.64649 8.64645C8.45123 8.84171 8.45123 9.15829 8.64649 9.35355L11.2929 12L8.64645 14.6465C8.45118 14.8418 8.45118 15.1583 8.64645 15.3536C8.84171 15.5489 9.15829 15.5489 9.35355 15.3536L12 12.7071L14.6465 15.3536C14.8418 15.5488 15.1583 15.5488 15.3536 15.3536C15.5489 15.1583 15.5489 14.8417 15.3536 14.6465L12.7071 12L15.3536 9.3536C15.5488 9.15834 15.5488 8.84175 15.3536 8.64649C15.1583 8.45123 14.8417 8.45123 14.6464 8.64649L12 11.2929L9.3536 8.64645Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircled);
export default __webpack_public_path__ + "static/media/close_circled.cc333dc68488fbdb3e83cfd8dc691e85.svg";
export { ForwardRef as ReactComponent };